<app-modal-view-bookings
  [id]="id()"
  [userId]="userId()!"
  [modal]="modal()!"
  [hidden]="!showed()"
  [values]="bookings()"
  [showDate]="true"
  (validatePickUpEventEmitter)="validatePickUp($event)"
  (validateDropOffEventEmitter)="validateDropOff($event)"
/>
